import React from 'react';
import { TrendingUp, ShieldCheck, Clock, DollarSign, Truck, Users } from 'lucide-react';
import './Benefits.css';
import { Link } from 'react-scroll';

const Benefits = () => {
  return (
    <section id="benefits" className="section section-blue">
      <div className="container">
        <div className="benefits-header">
          <h2 className="section-title">Resultados Reales para tu Negocio</h2>
          <p className="section-subtitle">
            VillaTracking no es solo un mapa, es una herramienta financiera y operativa. 
            Transforma la gestión de tu flota en ahorros medibles y mayor productividad.
          </p>
        </div>

        <div className="benefits-container">
          <div className="benefits-image-wrapper">
            <img src={'/img/benefits1.png'} alt="Rentabilidad con VillaTracking" className="floating-img" />
            <div className="experience-badge">
              <span className="badge-number">30%</span>
              <span className="badge-text">de ahorro<br/>en costos</span>
            </div>
          </div>

          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon-wrapper"><TrendingUp size={24} /></div>
              <div className="benefit-content">
                <h3>Productividad Máxima</h3>
                <p>Optimiza rutas y reduce tiempos de inactividad, mejorando la eficiencia de tus conductores.</p>
              </div>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon-wrapper"><DollarSign size={24} /></div>
              <div className="benefit-content">
                <h3>Reducción de Costos</h3>
                <p>Disminuye gastos de combustible auditando malos hábitos (Eco-driving) y el ralentí.</p>
              </div>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon-wrapper"><ShieldCheck size={24} /></div>
              <div className="benefit-content">
                <h3>Seguridad Activa</h3>
                <p>Reacciona al instante con comandos OTA de inmovilización y alertas perimetrales.</p>
              </div>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon-wrapper"><Clock size={24} /></div>
              <div className="benefit-content">
                <h3>Automatización</h3>
                <p>El Odómetro Virtual calcula los kilometrajes y te avisa de mantenimientos próximos.</p>
              </div>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-icon-wrapper"><Truck size={24} /></div>
              <div className="benefit-content">
                <h3>Vida Útil Extendida</h3>
                <p>Prolonga la vida de tus activos previniendo fallas antes de que ocurran.</p>
              </div>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon-wrapper"><Users size={24} /></div>
              <div className="benefit-content">
                <h3>Servicio de Excelencia</h3>
                <p>Ofrece a tus clientes tiempos de entrega precisos (ETA) con visibilidad en tiempo real.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="benefits-cta">
          <Link to="contact" spy={true} smooth={true} offset={-80} duration={500} className="btn btn-primary btn-lg">
            Quiero Optimizar Mi Flota
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Benefits;